import React from "react"
import PropTypes from "prop-types"

// Components
import CardHeader from "../CardHeader/CardHeader"
import ScoreChart from "../ScoreChart/ScoreChart"
import ErrorState from "../ErrorState/ErrorState"

const Performers = ({ topPerformers, stragglers }) => {
  return (
    <div className="d-flex flex-column flex-lg-row justify-content-between pt-3">
      {/* Top Performers */}
      <div className="mr-0 mr-lg-5 card card-border card-flex">
        <CardHeader
          header={{ title: "Top Performers" }}
          noBottomBorder="border-bottom-0 mt-2"
          indentHeader
          titleSize="h2"
        />
        {topPerformers.length ? (
          <div className="card-block mb-0 pt-0">
            <ScoreChart data={topPerformers} />
          </div>
        ) : (
          <div className="center-text error-bottom-margin">
            <ErrorState />
          </div>
        )}
      </div>

      {/* Stragglers */}
      <div className="card card-border card-flex">
        <CardHeader
          header={{ title: "Weakest Performers" }}
          noBottomBorder="border-bottom-0 mt-2"
          indentHeader
          titleSize="h2"
          className="demo-tour-step-5"
        />
        {stragglers.length ? (
          <div className="card-block mb-0 pt-0">
            <ScoreChart data={stragglers} />
          </div>
        ) : (
          <div className="center-text error-bottom-margin">
            <ErrorState />
          </div>
        )}
      </div>
    </div>
  )
}

export default Performers

Performers.propTypes = {
  topPerformers: PropTypes.arrayOf(
    PropTypes.shape({
      department: PropTypes.string,
      elevate_person_id: PropTypes.string,
      riskScore: PropTypes.number,
      name: PropTypes.string
    })
  ).isRequired,
  stragglers: PropTypes.arrayOf(
    PropTypes.shape({
      department: PropTypes.string,
      elevate_person_id: PropTypes.string,
      riskScore: PropTypes.number,
      name: PropTypes.string
    })
  ).isRequired
}
